import { z } from "zod";
import {
  githubProjectRepositorySchema,
  githubProjectSchema,
  projectSchema
} from "../project/index.js";
import { themeSchema } from "../theme/index.js";
import { nanoidSchema } from "../utility/index.js";
const headingRecordSchema = z.object({
  slug: z.string(),
  name: z.string(),
  level: z.coerce.number().int(),
  uid: nanoidSchema,
  parent: z.string().optional()
});
const publishAssetSchema = z.object({
  path: z.string(),
  data: z.string()
});
const publishDeployRequestSchema = z.object({
  token: z.string(),
  teamUid: nanoidSchema,
  publishUid: nanoidSchema,
  subdomain: z.string(),
  /** A map of page ids to YJS document ids */
  yjsDocs: z.record(z.string(), z.string()),
  /** A map of reference ids to YJS document ids */
  yjsReferences: z.record(z.string(), z.string()),
  project: projectSchema,
  theme: themeSchema,
  customDomain: z.string().nullable(),
  isPaid: z.boolean().optional(),
  preview: z.boolean().optional()
});
const publishGithubRequestSchema = z.object({
  token: z.string(),
  teamUid: nanoidSchema,
  publishUid: nanoidSchema,
  subdomain: z.string(),
  customDomain: z.string().optional().default(""),
  encryptedGithubToken: z.string(),
  project: githubProjectSchema.extend({
    repository: githubProjectRepositorySchema
  }),
  theme: themeSchema,
  isPaid: z.boolean().default(false),
  preview: z.boolean().optional()
});
const publishCliRequestSchema = z.object({
  token: z.string(),
  teamUid: nanoidSchema,
  publishUid: nanoidSchema,
  subdomain: z.string(),
  customDomain: z.string().optional().default(""),
  assets: publishAssetSchema.array(),
  documents: z.record(z.string(), z.string()),
  references: z.record(z.string(), z.string()),
  project: projectSchema,
  theme: themeSchema,
  isPaid: z.boolean().default(false),
  gitProjectUid: nanoidSchema,
  preview: z.boolean().optional()
});
const staticDocSchema = z.object({
  html: z.string(),
  headings: z.record(z.string(), headingRecordSchema),
  markdown: z.string()
});
const staticContentSchema = z.record(z.string(), staticDocSchema);
const sparsePublishDataSchema = z.object({
  project: projectSchema,
  theme: themeSchema,
  isPaid: z.boolean().default(false),
  typesenseKey: z.string(),
  typesenseHost: z.string(),
  typesenseCollection: z.string(),
  proxy: z.string().url()
});
const splitOutputDataSchema = z.object({
  staticDocs: staticContentSchema,
  errors: z.string().array()
});
export {
  headingRecordSchema,
  publishAssetSchema,
  publishCliRequestSchema,
  publishDeployRequestSchema,
  publishGithubRequestSchema,
  sparsePublishDataSchema,
  splitOutputDataSchema,
  staticContentSchema,
  staticDocSchema
};
//# sourceMappingURL=publish.js.map
